import { render, staticRenderFns } from "./LmInbox.vue?vue&type=template&id=213da416&scoped=true&"
import script from "./LmInbox.vue?vue&type=script&lang=js&"
export * from "./LmInbox.vue?vue&type=script&lang=js&"
import style0 from "./LmInbox.vue?vue&type=style&index=0&id=213da416&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213da416",
  null
  
)

export default component.exports